import { render, staticRenderFns } from "./TheoryList.vue?vue&type=template&id=9cf7a55a&scoped=true"
import script from "./TheoryList.vue?vue&type=script&lang=js"
export * from "./TheoryList.vue?vue&type=script&lang=js"
import style0 from "./TheoryList.vue?vue&type=style&index=0&id=9cf7a55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf7a55a",
  null
  
)

export default component.exports